var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemoLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.417 31.667q-.959 0-1.688-.729Q5 30.208 5 29.25v-18.5q0-.958.729-1.687.729-.73 1.688-.73h25.166q.959 0 1.688.73.729.729.729 1.687v18.5q0 .958-.729 1.688-.729.729-1.688.729Zm0-1.417h7.125V9.75H7.417q-.417 0-.709.292-.291.291-.291.708v18.5q0 .417.291.708.292.292.709.292Zm8.541 0h8.084V9.75h-8.084Zm9.5 0h7.125q.417 0 .709-.292.291-.291.291-.708v-18.5q0-.417-.291-.708-.292-.292-.709-.292h-7.125Zm-9.5 0V9.75v20.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoLayout);
export default __webpack_public_path__ + "static/media/demo-layout.9aed485a1e19ded4bee88e06b7e1f7ec.svg";
export { ForwardRef as ReactComponent };